import { TabsList, TabsTrigger } from 'DesignSystem/ui/tabs';

const TAB_TRIGGER_CLASS_NAME =
  'type-body rounded-none bg-transparent px-0 pb-2 pt-2 font-m leading-[19px] text-zinc-400 shadow-none data-[state=active]:border-b-2 data-[state=active]:border-indigo-600 data-[state=active]:bg-transparent data-[state=active]:text-zinc-900 data-[state=active]:shadow-none';

export function ItemSidebarTabs() {
  return (
    <TabsList
      aria-label="Item details"
      className="h-9 w-full justify-start gap-6 rounded-none border-0 border-b border-zinc-200 bg-transparent px-4 py-0"
    >
      <TabsTrigger value="pack_contents" className={TAB_TRIGGER_CLASS_NAME}>
        Pack Contents
      </TabsTrigger>
      <TabsTrigger value="overview" className={TAB_TRIGGER_CLASS_NAME}>
        Overview
      </TabsTrigger>
    </TabsList>
  );
}
